export default __webpack_public_path__ + "static/media/spyware.460fe3f7.svg";